import React from "react";
import { useState } from "react";
import login from "../../jsons/login.json"

const Login: React.FC = (props:any) =>{
    const [isLoading, setIsLoading] = useState(false);
  // const [formValues, setFormValues] = useState({
  //   email: "useremail@domain.cl",
  //   password: "my-secret-password",
  // });
  const [user, setCredentials] = useState({
    username: ''
    , password: ''
  });
  const validarLogin =(event:any) =>{
    event.preventDefault();

    if(user.username === login.username && user.password === login.password ){
        window.location.href ='/carga';


    }
    else{
      
    }
  }

    // api_instance.post("/login", { site: "mesu", username: user.username, password: user.password }).then((res) => {
    //   console.log('aqui');
    // })

    
    return (
        <div className="global-container">
          <div className="card login-form">
            <div className="card-body">
              {/* <div className="text-center">
                <img
                  className="login-logo"
                  src="img/cadem/logo-cadem.jpeg"
                  alt="Logo Cadem"
                />
              </div> */}
              <h3 className="card-title text-center">Iniciar Sesión.</h3>
              <div className="card-text">
                <form onSubmit={validarLogin}>
                  <div className="row form-group mb-2">
                    <div className="col-md-5 mt-2 text-center">
                      Usuario:
                    </div>
                    <div className="col-md-8">
                      <input
                        type="text"
                        name="username"
                        onChange={e => setCredentials({ ...user, username: e.target.value })}
                        value={user.username}
                        //disabled={isLoading}
                        className="form-control form-control-sm"
                        placeholder="Usuario"
                      />
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col-md-5 text-center mt-3">
                      Contraseña:
                    </div>
                    <div className="col-md-8">
                      <input
                        type="password"
                        name="password"
                        value={user.password}
                        onChange={e => setCredentials({ ...user, password: e.target.value })}
                        //disabled={isLoading}
                        className="mt-2 form-control form-control-sm"
                        placeholder="contraseña"
                      />
                    </div>
                  </div>
                  <div className="row mt-2 text-center">
                    <div className="">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block mt-4 mb-2"
                        disabled={isLoading}
                      >
                        Iniciar sesión.
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      );
}
export default Login;